/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    PromoTokenType,
    PromoTokenTypeFromJSON,
    PromoTokenTypeFromJSONTyped,
    PromoTokenTypeToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Represents a single promo token reward.
 * @export
 * @interface PromoToken
 */
export interface PromoToken {
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    description?: string;
    /**
     * 
     * @type {PromoTokenType}
     * @memberof PromoToken
     */
    type: PromoTokenType;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    targetUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoToken
     */
    isEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoToken
     */
    isBranded?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromoToken
     */
    couponCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PromoToken
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    expiresAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoToken
     */
    maxLimit?: number;
}

export function PromoTokenFromJSON(json: any): PromoToken {
    return PromoTokenFromJSONTyped(json, false);
}

export function PromoTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': PromoTokenTypeFromJSON(json['type']),
        'targetUrl': !exists(json, 'targetUrl') ? undefined : json['targetUrl'],
        'isEnabled': json['isEnabled'],
        'isBranded': !exists(json, 'isBranded') ? undefined : json['isBranded'],
        'couponCodes': !exists(json, 'couponCodes') ? undefined : json['couponCodes'],
        'qrImageUrl': !exists(json, 'qrImageUrl') ? undefined : json['qrImageUrl'],
        'expiresAt': !exists(json, 'expiresAt') ? undefined : json['expiresAt'],
        'maxLimit': !exists(json, 'maxLimit') ? undefined : json['maxLimit'],
    };
}

export function PromoTokenToJSON(value?: PromoToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'description': value.description,
        'type': PromoTokenTypeToJSON(value.type),
        'targetUrl': value.targetUrl,
        'isEnabled': value.isEnabled,
        'isBranded': value.isBranded,
        'couponCodes': value.couponCodes,
        'qrImageUrl': value.qrImageUrl,
        'expiresAt': value.expiresAt,
        'maxLimit': value.maxLimit,
    };
}


